import { notification } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useState, useEffect } from 'react';
import { createRoom } from 'services/api';
import type { Room } from 'services/api';
import type { RoomFormValues } from '../../types';

interface UseCopyProps {
  hide: () => void;
  onItemCopy: () => void;
  buildingId: number;
  selectedRoom: Room | null;
}

export const useCopy = ({ hide, onItemCopy, buildingId, selectedRoom }: UseCopyProps) => {
  const [form] = useForm<RoomFormValues>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedRoom) {
      form.setFieldsValue({
        ...selectedRoom,
        subjectsIds: selectedRoom.subjects?.map((subject) => subject.id),
      });
    }
  }, [selectedRoom]);

  const onSubmit = () => {
    form.validateFields().then((values) => {
      createRoom({
        ...values,
        buildingId: buildingId,
      })
        .then(() => {
          hideModal();
          onItemCopy();
        })
        .catch((error) => {
          notification.error({ message: 'Не удалось создать аудиторию' });
          throw error;
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const hideModal = () => {
    hide();
    form.resetFields();
  };

  return {
    state: { form, loading },
    methods: { hideModal, onSubmit },
  };
};
